"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectTemplateUtil = void 0;
class ProjectTemplateUtil {
    static projectDeduplication(sourceArr, targetArr) {
        return targetArr.filter(t => sourceArr.every(s => s.id !== t.id));
    }
}
exports.ProjectTemplateUtil = ProjectTemplateUtil;
